import React, { useState, useEffect, use } from "react";
import { Link, useNavigate } from "react-router-dom";
import { dashboardIcon, taskAssign } from "../../config/images";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./UserProfile.css";
import { Button } from "../../components/Button/button";
import { Grid, Table, TableBody, TableRow, TableCell, Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateUserProfile, userPropfile } from "../../config/services";
import { toast } from "react-toastify";
import Shimmer from "../../components/Shimmer/Shimmer";
import { setUserDetails } from "../../container/Login/slice/userSlice";
import translations from "../../config/language";



const UserProfile = () => {
  const navigate = useNavigate();
  const [isEdit, setEdit] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [userImage, setUserImage] = useState(null);
  const [formValues, setFormValues] = useState({
    profileImage: null,
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    mobileNumber: "",
    email: "",
  });

  const { id } = useSelector(state => state.userState);

  const dispatch = useDispatch();

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };


  const handleEdit = () => {
    setEdit(true);
  };

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormValues({ ...formValues, profileImage: reader.result });
      };
      reader.readAsDataURL(file);
    }
    setUserImage(file)
  };


  const handleUpdateProfile = async () => {
    const formData = new FormData(); // ✅ Create FormData object


    // formData.append("profile_photo", userImage); // ✅ Attach file

    if (userImage) {
      // User uploaded a new image, use the selected file
      formData.append("profile_photo", userImage);
    }
    formData.append("first_name", formValues.firstName);
    formData.append("middle_name", formValues.middleName);
    formData.append("last_name", formValues.lastName);
    formData.append("gender", formValues.gender === "male" ? 0 : 1);
    // formData.append("mobile_number", `91${formValues.mobileNumber}`);
    const mobileNumber = formValues.mobileNumber.startsWith("91")
      ? formValues.mobileNumber
      : `+91${formValues.mobileNumber}`;
    formData.append("mobile_number", mobileNumber);
    formData.append("email", formValues.email);


    try {
      const resp = await updateUserProfile(id, formData)

      if (resp.data.success) {
        notifySuccess(resp.data.message);
        setEdit(false);
        dispatch(
          setUserDetails({
            token: resp.data.payload.token,
            id: resp.data.payload.id,
            name: resp.data.payload.name,
            firstName: resp.data.payload.first_name,
            middleName: resp.data.payload.middle_name,
            lastName: resp.data.payload.last_name,
            gender: resp.data.payload.gender,
            mobileNumber: resp.data.payload.mobile_number,
            email: resp.data.payload.email,
            role: resp.data.payload.role,
            profilePhoto: resp.data.payload.profile_photo,
            is_mobile_verify: resp.data.payload.is_mobile_verify,
            is_user_registered: resp.data.payload.is_user_registered,
            is_active: resp.data.payload.is_active,
            is_delete: resp.data.is_delete
          })
        );
      }


    } catch (error) {
      notify(error.message)
    }
  };


  const fetchData = async () => {
    try {
      setIsLoading(true);
      const resp = await userPropfile(id);

      if (resp.status == 200) {
        setIsLoading(false);
        setFormValues({
          profileImage: resp.data.profile_photo,
          firstName: resp.data.first_name,
          middleName: resp.data.middle_name,
          lastName: resp.data.last_name,
          gender: resp.data.gender == 0 ? "Male" : "Female",
          mobileNumber: `${resp.data.mobile_number}`,
          email: resp.data.email
        });
      }
    }

    catch (error) {

    }
  }

  useEffect(() => {
    fetchData();
  }, [])


  const language = process.env.REACT_APP_LANGUAGE;
  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center">
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].profile}
            </Typography>
          </Box>

          <div className="edit-profile">
            {isEdit ? (
              <Button
                title={translations[language].updateProfile}
                classname={"custom-button"}
                onClick={handleUpdateProfile}
                loading={loading}
              />
            ) : (
              <Button
                title={translations[language].editProfile}
                classname={"border-btn"}
                onClick={handleEdit}
              // loading={loading}
              />
            )}
          </div>
        </Box>
        <Box className="user-profile">
          <Grid container spacing={2}>

            <Grid item xs={12} md={8} lg={8}>
              {/* Render shimmer for input fields while loading */}
              {["firstName", "middleName", "lastName", "gender", "mobileNumber", "email"].map((field, index) => (
                <Grid container key={index} style={index === 0 ? { borderTop: "1px solid #D9D9D9" } : {}}>
                  <Grid item xs={12} sm={4} md={3} lg={3} className="grid-item" style={{paddingLeft: "20px"}}>
                    {field == "firstName" ? translations[language].firstName :
                      field == "middleName" ? translations[language].middleName :
                        field == "lastName" ? translations[language].lastName :
                          field == "gender" ? translations[language].gender :
                            field == "mobileNumber" ? translations[language].mobileNumber :
                              translations[language].email
                    }
                  </Grid>
                  <Grid item xs={12} sm={8} md={9} lg={9} className="grid-item">
                    {loading ? (
                      <Shimmer style={{ height: "20px", width: "100%" }} />
                    ) : field === "gender" && isEdit ? (
                      // ✅ Render radio buttons when `isEdit` is true for gender
                      <div style={{ display: "flex", gap: "10px" }}>
                        <input
                          type="radio"
                          name="gender"
                          value={translations[language].male}
                          checked={formValues.gender === "Male"}
                          onChange={handleChange}
                        />
                        <label htmlFor="Male" style={{ paddingRight: "10px", borderRight: "1px solid  #D9D9D9" }}>
                          {translations[language].male}
                        </label>
                        <input
                          type="radio"
                          name="gender"
                          value={translations[language].female}
                          checked={formValues.gender === "Female"}
                          onChange={handleChange}
                        />
                        <label htmlFor="Female">{translations[language].female}</label>
                      </div>
                    ) : (
                      <input
                        type="text"
                        value={formValues[field]}
                        name={field}
                        disabled={!isEdit}
                        onChange={handleChange}
                        style={{ width: "100%", border: "none", background: "none" }}
                      />
                    )}
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              {/* <img src={dashboardIcon.userImage} alt="user-image" className="user-image" /> */}
              {/* Show shimmer for image while loading */}
              <div style={{ position: "relative", display: "inline-block" }}>
                {loading ? (
                  <Shimmer style={{ height: "244px", width: "295px" }} />
                ) : (
                  <img
                    src={formValues.profileImage}
                    alt="user-image"
                    className="user-image"
                  />
                )}
                {isEdit && !loading && (
                  <label
                    htmlFor="profile-image-input"
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "30px",
                      cursor: "pointer",
                    }}
                  >
                    <img src={dashboardIcon.editIcon} alt="edit-icon" />
                    <input
                      id="profile-image-input"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                    />
                  </label>
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default UserProfile;
